import { useEffect, useState } from "react";
import type { FC } from "react";
import ReactGA from "react-ga4";

interface AnalyticsStatus {
  initialized: boolean;
  scriptLoaded: boolean;
  disabled: boolean;
  testMode: boolean;
}

const AnalyticsStatusComponent: FC = () => {
  const [status, setStatus] = useState<AnalyticsStatus>({
    initialized: false,
    scriptLoaded: false,
    disabled: false,
    testMode: false,
  });

  useEffect(() => {
    const checkStatus = () => {
      const newStatus = {
        initialized: ReactGA.isInitialized,
        scriptLoaded: !!document.querySelector(
          'script[src*="googletagmanager"]',
        ),
        disabled: false, // Always enabled now
        testMode: import.meta.env.DEV,
      };

      setStatus(newStatus);

      // Always log status for debugging
      console.log("🔍 Analytics Status (react-ga4):", {
        ...newStatus,
        measurementId: "G-3ZC5BVTKEQ",
        currentPath: window.location.pathname,
        timestamp: new Date().toISOString(),
      });
    };

    // Check immediately
    checkStatus();

    // Check again after a delay to catch async script loading
    const timer = setTimeout(checkStatus, 3000);

    return () => clearTimeout(timer);
  }, []);

  // Only show in development when there are critical issues (not initialized)
  // In development, we now show this info in the footer InfoIcon instead
  // This prevents the overlay from covering the menu in local development
  const shouldShow = !import.meta.env.DEV && !status.initialized;

  if (!shouldShow) {
    return null;
  }

  return (
    <div
      className="position-fixed z-50 rounded p-2 text-xs"
      style={{
        top: "10px",
        right: "10px",
        background: !status.initialized ? "#ff4444" : "#44ff44",
        color: "white",
        fontFamily: "monospace",
      }}
    >
      <div>
        <strong>GA4 Status</strong>
      </div>
      <div>initialized: {status.initialized ? "✅" : "❌"}</div>
      <div>script: {status.scriptLoaded ? "✅" : "❌"}</div>
      <div>disabled: {status.disabled ? "❌" : "✅"}</div>
      <div>test mode: {status.testMode ? "🧪" : "🚀"}</div>
    </div>
  );
};

export default AnalyticsStatusComponent;
